import React from 'react';
import styles from './AnimatedVisuals.module.css';

const DroneVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.droneHeader}>
        <div className={styles.droneIcon}>🚁</div>
        <span className={styles.droneTitle}>IoT Drone System</span>
      </div>
      <div className={styles.droneScene}>
        <div className={styles.drone}>
          <div className={styles.droneBody}></div>
          <div className={styles.propeller} style={{ top: '-15px', left: '50%' }}></div>
          <div className={styles.propeller} style={{ top: '50%', left: '-15px' }}></div>
          <div className={styles.propeller} style={{ top: '50%', right: '-15px' }}></div>
          <div className={styles.propeller} style={{ bottom: '-15px', left: '50%' }}></div>
        </div>
        <div className={styles.signalWave} style={{ animationDelay: '0s' }}></div>
        <div className={styles.signalWave} style={{ animationDelay: '0.5s' }}></div>
        <div className={styles.signalWave} style={{ animationDelay: '1s' }}></div>
        <div className={styles.groundGrid}></div>
      </div>
      <div className={styles.droneStatus}>
        <span className={styles.statusDot}></span>
        <span>Connected & Monitoring</span>
      </div>
    </div>
  );
};

export default DroneVisual;

